import {
  ChatStoreState,
  LOADING_STATE,
  ThreadLoadingState,
} from '@/store/reducers/ChatStore';
import { getThreadFromApi, Thread } from '@/models/Thread';
import {
  GetThreadResponseBody,
  GetUserThreadsResponseBody,
} from '@/api/ApiResponse';

import { PayloadAction } from '@reduxjs/toolkit';

export function handleFetchUserThreadsStartingReducer(
  state: ChatStoreState,
): ChatStoreState {
  return {
    ...state,
    initializeThreadsState: LOADING_STATE.LOADING,
    threads: {},
    threadsLoadingStates: {},
  };
}

export function handleFetchUserThreadsCompleteReducer(
  state: ChatStoreState,
  action: PayloadAction<GetUserThreadsResponseBody>,
): ChatStoreState {
  const threadsData = action.payload;

  const threadsList: Thread[] = (threadsData?.threads || []).map((data) =>
    getThreadFromApi(data),
  );

  const threadsMap: Record<string, Thread> = {};
  const threadsLoadingStates: Record<string, ThreadLoadingState> = {};

  threadsList.forEach((thread: Thread) => {
    threadsMap[thread.id] = thread;
    threadsLoadingStates[thread.id] = {
      isInitialized: false, // only the latest message of a thread has been fetched at this point
      loadingState: LOADING_STATE.NOT_STARTED,
    };
    return threadsMap;
  });

  return {
    ...state,
    initializeThreadsState: LOADING_STATE.LOADED,
    threads: threadsMap,
    threadsLoadingStates,
  };
}

export function handleFetchUserThreadsErrorReducer(
  state: ChatStoreState,
): ChatStoreState {
  return {
    ...state,
    initializeThreadsState: LOADING_STATE.ERROR,
  };
}

export function handleFetchThreadStartingReducer(
  state: ChatStoreState,
  action: PayloadAction<undefined, string, { arg: string }>,
): ChatStoreState {
  const threadId = action.meta.arg;
  return {
    ...state,
    threads: {
      ...state.threads,
    },
    threadsLoadingStates: {
      ...state.threadsLoadingStates,
      [threadId]: {
        isInitialized:
          state.threadsLoadingStates[threadId]?.isInitialized || false,
        loadingState: LOADING_STATE.LOADING,
      },
    },
  };
}

export function handleFetchThreadCompleteReducer(
  state: ChatStoreState,
  action: PayloadAction<GetThreadResponseBody>,
): ChatStoreState {
  const thread = getThreadFromApi(action.payload.thread);
  return {
    ...state,
    threads: {
      ...state.threads,
      [thread.id]: thread,
    },
    threadsLoadingStates: {
      ...state.threadsLoadingStates,
      [thread.id]: {
        isInitialized: true,
        loadingState: LOADING_STATE.LOADED,
      },
    },
  };
}

export function handleFetchThreadErrorReducer(
  state: ChatStoreState,
): ChatStoreState {
  return {
    ...state,
    threads: {
      ...state.threads,
    },
    threadsLoadingStates: {
      ...state.threadsLoadingStates,
    },
  };
}
